var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-side-menu"},[(!_vm.isCondensed)?_vm._m(0):_c('SideNav')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('VuePerfectScrollbar',{staticClass:"h-100",attrs:{"settings":_vm.settings}},[_c('SideNav')],1)
}]

export { render, staticRenderFns }